<div id="kazaplan" style="height: 100%"></div>

<!--<ng-container *ngIf="!!kazaplanInstance && !isPlanEditableByKozikash && !isReadOnlyModalClosed">
  <div class="modal-backdrop">
    <div class="kazaplan-read-only-modal">
      <button class="close" (click)="closeReadOnlyModal()">
        <kz-icons [name]="'cross'"></kz-icons>
      </button>
      <h5 i18n="@@kozikash.read_only_modal.title">This plan is in read-only mode (non-editable)</h5>
      <p i18n="@@kozikash.read_only_modal.body">You can view this plan, but you can't edit it.<br/><strong>To edit it, you have to subscribe to a premium subscription.</strong></p>
      <div class="actions">
        <button kzButton buttonStyle="borderless" buttonContext="tools"><span i18n="@@kozikash.read_only_modal.subscribe">Reactivate my subscription</span></button>
        &nbsp;
        &nbsp;
        &nbsp;
        <button (click)="closeReadOnlyModal()" kzButton buttonStyle="flat" buttonContext="tools"><span i18n="@@kozikash.read_only_modal.view_plan">View my plan</span></button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isPlanEditableByKozikash && isReadOnlyModalClosed">
  <div class="kazaplan-read-only-overlay">
    <h5 i18n="@@kozikash.read_only_overlay.title">This plan is in read-only</h5>
    <button kzButton buttonStyle="flat" buttonContext="tools"><span i18n="@@kozikash.read_only_overlay.subscribe">View the offers to edit it</span></button>
  </div>
</ng-container>-->

<app-da-location  [adLocation]="adLocation" [adLocationSettings]="adLocationSettings"
                 [adYOffset]="((moodWindowOpened$ | async) || (kitchenPriceEnabled$ | async)) ? 12 : null"></app-da-location>

<ng-container *ngIf="locale === 'fr'">
  <app-kazaplan-menu *appNgIfIsCommunity="{forceServerSide: true}" [ngClass]="{'kazaplan-menu--connected': userStoreService.isLoggedInStore | async, 'kazaplan-menu--new-plan': planNew, 'kazaplan-menu--save-plan': planSaved}" [@fadeInAnimation]="{params : {time : '2000ms', delay : '2050ms', timeLeave : '0ms', delayLeave : '0ms' }}"></app-kazaplan-menu>
</ng-container>

<!--<app-kazaplan-menu-plan #kzpMenuPlan *ngIf="(config.mode == 'edit' || config.mode == 'new')" [planId]="planId"></app-kazaplan-menu-plan>-->
